import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Col, Container, Image, Row, Stack } from 'react-bootstrap';
import logoWhite from '../../../assets/logo_white.svg';
import facebook from '../../../assets/icon/facebook.svg';
import linkedin from '../../../assets/icon/linkedin.svg';
import twitter from '../../../assets/icon/twitter.svg';
import { LanguageProvider } from '../../../core/language-provider';
import { useCandidatePrivacy } from '../../CandidatePrivacyModal';

export default function FooterBlock() {
    const { open: openCandidatePrivacy } = useCandidatePrivacy();
    useEffect(() => { }, []);

    const colors = {
        bg: '#0B1224',
        text: '#CFE3F5',
        muted: '#9BB4CC',
        link: '#2FAAE0',
        divider: 'rgba(255,255,255,0.1)'
    };

    const linkStyle = { color: colors.link, textDecoration: 'none' };
    const small = { fontSize: 14 };

    return (
        <>
            <Container fluid className='pt-5 pb-0' style={{ backgroundColor: colors.bg, color: colors.text }}>
                {/* Layout a righe come da specifica */}
                <Container>
                    {/* Row 1: solo logo */}
                    <Row className='gy-4'>
                        <Col xs={12} className='text-center text-md-start'>
                            <Image src={logoWhite} alt='Cimolai' height={40} className='mb-4 mx-auto mx-md-0 d-block' />
                        </Col>
                    </Row>

                    {/* Row 2: tre colonne -> dati azienda, elenco pagine, elenco progetti */}
                    <Row className='gy-5 gx-4 align-items-start footer-cols'>
                        <Col lg={5} md={12} className='text-center text-md-start'>
                            <div className='mb-3'>
                                <Link to='/' style={linkStyle}>Cimolai S.p.A</Link>
                            </div>
                            <p style={{ color: colors.muted }} className='mb-0'>
                                {LanguageProvider.get('footerTexts.payoff')}
                            </p>
                        </Col>
                        <Col lg={4} md={6} className='text-center text-md-start'>
                            <Row className='gx-4 gy-4 gy-md-0'>
                                <Col md={6} className='text-center text-md-start'>
                            <div className='mb-3' style={{ color: colors.link, fontWeight: 600 }}>{LanguageProvider.get('footerTexts.headOffice')}</div>
                                    <div style={small}>
                                        Corso Lino Zanussi, 26<br />
                                        33080 Porcia (PN)<br />
                                        Italy
                                    </div>
                                    <div className='mt-3' style={small}>
                                        Tel: +39 0434 5581<br />
                                        Fax: +39 0434 361401<br />
                                        Email: <a href='mailto:info@cimolai.com' style={linkStyle}>info@cimolai.com</a><br />
                                        Email: <a href='mailto:media@cimolai.com' style={linkStyle}>media@cimolai.com</a>
                                    </div>
                                </Col>
                                <Col md={6} className='text-center text-md-start'>
                                    <div className='mb-3' style={{ color: colors.link, fontWeight: 600 }}>{LanguageProvider.get('footerTexts.regOffice')}</div>
                                    <div style={small}>
                                        Viale Pasteur, 49<br />
                                        00144 – Rome (RM)<br />
                                        Italy
                                    </div>
                                    <div className='mt-3' style={small}>
                                        PEC: <a href='mailto:cimolaispa@legalmail.it' style={linkStyle}>cimolaispa@legalmail.it</a>
                                    </div>
                                </Col>
                            </Row>
                        </Col>
                        <Col lg={3} md={6} className='text-center text-md-start'>

                            <div className='mb-3' style={{ color: colors.link, fontWeight: 600 }}>{LanguageProvider.get('footerTexts.contactUs')}</div>
                            <div className='mb-3' style={small}>
                                <a href='mailto:info@cimolai.com' style={linkStyle}>info@cimolai.com</a>
                            </div>
                            <div className='mb-2' style={{ color: colors.link, fontWeight: 600 }}>{LanguageProvider.get('footerTexts.followUs')}</div>
                            <Stack direction='horizontal' gap={3} className='justify-content-center justify-content-md-start'>
                                <Image src={facebook} alt='Facebook' height={18} />
                                <Image src={linkedin} alt='LinkedIn' height={18} />
                                <Image src={twitter} alt='Twitter' height={18} />
                            </Stack>
                        </Col>
                    </Row>


                    <hr className='my-5' style={{ borderColor: colors.divider }} />

                    {/* Bottom legal bar: single row with items adjacent */}
                    <Row className='align-items-center py-4' style={{ fontSize: 12, color: colors.muted }}>
                        <Col xs={12} className='text-center text-md-start'>
                            <Stack direction='horizontal' gap={3} className='flex-wrap justify-content-center justify-content-md-start'>
                                <span>© {new Date().getFullYear()} Cimolai S.p.A. {LanguageProvider.get('footerTexts.legal.rightsReserved')}</span>
                                <a href={LanguageProvider.get('footerTexts.legal.privacyPolicyUrl')} target='_blank' rel='noreferrer' style={linkStyle}>{LanguageProvider.get('footerTexts.legal.privacyPolicy')}</a>
                                <a href={LanguageProvider.get('footerTexts.legal.cookiePolicyUrl')} target='_blank' rel='noreferrer' style={linkStyle}>{LanguageProvider.get('footerTexts.legal.cookiePolicy')}</a>
                                <a href='/privacy-candidati' onClick={openCandidatePrivacy} style={linkStyle}>{LanguageProvider.get('footerTexts.legal.candidatesPrivacyPolicy')}</a>
                            </Stack>
                        </Col>
                    </Row>
                </Container>
            </Container>
        </>
    );
};
